import { GET_PLANS, FETCHING_PLANS, FETCHED_PLANS, CLEAR_ALL, LOCATION_CHANGE, SHOW_PLANS_MODAL } from "../actions/constants";
import defaults from "./defaults";

const plansReducer = (state = defaults.plans, { type, payload }) => {
  switch (type) {
    case GET_PLANS:
      return { ...state, list: payload, last_fetched: new Date() };
    case FETCHING_PLANS:
      return { ...state, fetching: payload };
    case FETCHED_PLANS:
      return { ...state, fetched: payload };
    case SHOW_PLANS_MODAL:
      return { ...state, show: payload };
    case LOCATION_CHANGE:
      return { ...state, show: false };
    case CLEAR_ALL:
      return defaults.plans;
    default:
      return state;
  }
};

export default plansReducer;